import { render, staticRenderFns } from "./ExamQuestions.vue?vue&type=template&id=229ad9df&"
import script from "./ExamQuestions.vue?vue&type=script&lang=js&"
export * from "./ExamQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ExamQuestions.vue?vue&type=style&index=0&id=229ad9df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports